module.exports = __webpack_public_path__ + "assets/img/btn-detail-b5e2dba8.png";